import { useParams } from "react-router-dom";
import "./KnowledgeArticle.module.css";
import Header from "@/reusable_sections/Header";
import ArticleHero from "./sections/ArticleHero";
import PostContent from "./sections/PostContent";
import LatestNews from "./sections/LatestNews";
import Footer from "@/reusable_sections/Footer";
export default function KnowledgeArticlePage() {
  const {
    slug
  } = useParams();
  return <div>
      <Header />
      <ArticleHero slug={slug} />
      <PostContent slug={slug} />
      <LatestNews />
      <Footer />
    </div>;
}